var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"layout":"tabbed"}},[_c('page-header-new',{attrs:{"title":_vm.pageTitle}}),_vm._v(" "),_c('page-tabs',{attrs:{"tabs":_vm.tabs}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4120eef8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/email-saved-rows/pages/EmailRowsPage.vue
// module id = null
// module chunks = 